import { RecordGroups } from '@/features/record-groups/components/RecordGroups'

export function RecordGroupsPage() {
  return <RecordGroups />
}
